import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

interface PageProps {
  children: ReactNode;
  title?: string;

  [key: string]: unknown;
}

export default function Page(props: PageProps) {
  const { children, title = '', ...rest } = props;

  return (
    <Box sx={{ width: '100%' }} {...rest}>
      <Helmet>
        <title>
          {title ? title : 'Autogestión'} - Municipalidad de San Miguel
        </title>
      </Helmet>
      <Header />
      {children}
      <Footer />
    </Box>
  );
}
